import React, { useMemo, useState } from "react";

import Viewer from "react-viewer";
import Loader from "../../../components/Loader";
import { convertStringToArray, extractDate } from "../../../Utils/utils";
import { useSelector } from "react-redux";
import { useGetProtectedApiDataQuery } from "../../../redux/services/apiSlice";
import PageLastUpdated from "../../../components/shared/PageLastUpdated";
import ShowTable from "../../../components/ShowTable";
import { useLanguageTranslation } from "../../../hooks/useLanguageTranslation";

function PaintingCompetition() {
  const { languageType } = useSelector((state) => state.homeSlice);
  const { getText } = useLanguageTranslation();

  const {
    data: paintingCompetitionPhotos,
    error,
    isLoading,
  } = useGetProtectedApiDataQuery({
    url: "painting_competition",
    lang: languageType,
  });

  const [visible, setVisible] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const [currentImages, setCurrentImages] = useState([]);
  const openViewer = (images, index) => {
    setCurrentImages(
      images.map((img) => ({
        src: `${process.env.REACT_APP_IMAGE_URL}/${img.file_path}`,
        alt: img.title,
      }))
    );
    setActiveIndex(index);
    setVisible(true);
  };

  const paintingGallery = convertStringToArray(
    paintingCompetitionPhotos?.[0]?.field_events_image
  );

  const paintingData = convertStringToArray(
    paintingCompetitionPhotos?.[0]?.field_painting_competition_files
  );

  const lastUpdatedOn = useMemo(() => {
    return extractDate(paintingCompetitionPhotos?.[0]);
  }, [paintingCompetitionPhotos]);

  if (isLoading) {
    return <Loader />;
  }

  if (error) {
    return <p>Error: {error.message}</p>;
  }

  return (
    <section className="ourCompany">
      <div className="container">
        <PageLastUpdated lastUpdatedOn={lastUpdatedOn} />
        <ShowTable title="Painting Competition" data={paintingData} />

        <div className="title-sec mt-4">
          <h2>{getText("Photo Gallery", "फोटो गैलरी")}</h2>
          <div className="row mb-5">
            {paintingGallery.length === 0 ? (
              <p>No photos available</p>
            ) : (
              paintingGallery.map((item, index) => (
                <div
                  key={index}
                  className="col-12 col-sm-12 col-md-3 col-lg-3 mvDescWrap mb-3 print-gallery3"
                >
                  <div className="card-sec painting-sec">
                    <div className="img-sec">
                      <a
                        className="masonry-item"
                        onClick={() => {
                          openViewer(paintingGallery, index);
                        }}
                      >
                        <img
                          alt={item.file_path}
                          src={`${process.env.REACT_APP_IMAGE_URL}/${item.file_path}`}
                        />

                        <div className="desc-sec">
                          <p>
                            {item.title.length > 35
                              ? `${item.slice(0, 35)}...`
                              : item.title}
                          </p>
                        </div>
                      </a>
                    </div>
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
        {/* table section */}
      </div>
      <Viewer
        visible={visible}
        onClose={() => setVisible(false)}
        onMaskClick={() => setVisible(false)}
        images={currentImages}
        activeIndex={activeIndex}
        rotatable={false}
        zoomable={true}
        scalable={false}
        drag={false}
      />
    </section>
  );
}

export default PaintingCompetition;
